export interface FieldErrorProps {
  /** 沒有值時不渲染 */
  message?: string;
}

/**
 * 欄位下方的錯誤訊息。
 *
 * 訊息貼著出錯的那一個欄位，而不是集中在表單底部：底部的單一訊息在多個欄位同時出錯時
 * 只講得出其中一件事，而且欄位一多就離出錯的地方越來越遠。
 *
 * `role="alert"` 讓螢幕閱讀器在訊息出現時立刻朗讀，因為驗證在送出後才跑，
 * 使用者的焦點此時不一定還在那個欄位上。
 */
export function FieldError({ message }: FieldErrorProps) {
  if (!message) return null;

  return (
    <p role="alert" className="text-xs text-error">
      {message}
    </p>
  );
}
